<template>
  <PersonalInfoComponent />
</template>

<script>
// @ is an alias to /src
import PersonalInfoComponent from "@/components/Account/Pages/PersonalInfo/PersonalInfo.vue";

export default {
  name: "Account",
  components: {
    PersonalInfoComponent
  }
};
</script>
